import { toast } from '@postscript/components';
import { FormikErrors } from 'formik';
import { ConfigValues } from '../types';
import { configValuesToCommonName } from './configValuesToCommonName';

export const getShopperTrialStartedKey = (shopId: number) =>
  `shop-${shopId}-shopper-trial-started`;

export const getShopperSelfServePromoBannerDismissedKey = (shopId: number) =>
  `shop-${shopId}-shopper-self-serve-promo-banner-dismissed`;

export const getShopperIsHereBannerDismissedKey = (shopId: number) =>
  `shop-${shopId}-shopper-is-here-banner-dismissed`;

export const getActivateShopperBannerDismissedKey = (shopId: number) =>
  `shop-${shopId}-activate-shopper-banner-dismissed`;

export const getDemoShopperModalShownKey = (shopId: number) =>
  `shop-${shopId}-demo-shopper-modal-shown`;

/**
 * Returns the Terms of Service URL for a given shop domain.
 */
export const getShopperTermsUrl = (shopDomain: string) =>
  `https://terms.pscr.pt/legal/shop/${shopDomain}/terms_of_service`;

/**
 * Returns the Privacy Policy URL for a given shop domain.
 */
export const getShopperPrivacyPolicyUrl = (shopDomain: string) =>
  `https://terms.pscr.pt/legal/shop/${shopDomain}/privacy_policy`;

export const validateFormValues = (
  values: Partial<ConfigValues>,
  errors: FormikErrors<Partial<ConfigValues>>,
) => {
  const invalidValues = Object.keys(errors).map((key) =>
    configValuesToCommonName(key as keyof ConfigValues, values),
  );
  if (invalidValues.length > 0) {
    toast.error(
      `The following fields must have valid data and be populated: ${invalidValues
        .filter((str) => str !== null)
        .join(', ')}.`,
    );
    return false;
  }
  return true;
};
